import React, { useEffect, useState } from 'react';
import api from '../services/api';

const TechUserFilter = ({ value, onChange, className = '', allLabel = 'All teammates' }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get('/tech-tasks/assignees').then((r) => setUsers(r.data.users || [])).catch(() => {});
  }, []);

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full sm:w-auto px-3 py-2.5 rounded-xl bg-slate-900 border border-slate-800 text-white text-sm focus:outline-none focus:ring-2 focus:ring-teal-500/40 ${className}`}
    >
      <option value="all">{allLabel}</option>
      {users.map((u) => (
        <option key={u.id} value={u.id}>{u.name}</option>
      ))}
    </select>
  );
};

export default TechUserFilter;
